var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.activeStep
    ? _c(
        "div",
        [
          _c("div", {
            staticClass: "custom-onboarding-overlay",
            on: {
              click: function($event) {
                return _vm.$emit("close")
              }
            }
          }),
          _vm._v(" "),
          _c(
            "b-popover",
            {
              key: _vm.activeStep.target,
              attrs: {
                target: _vm.activeStep.target,
                show: true,
                placement: "bottom",
                triggers: "manual",
                boundary: "viewport",
                container: "body",
                "custom-class": "custom-popover"
              }
            },
            [
              _c("div", { staticClass: "custom-popover-body" }, [
                _c("p", [_vm._v(_vm._s(_vm.activeStep.content))]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify-content-between align-items-center mt-2"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "cursor-pointer d-flex align-items-center text-muted",
                        on: {
                          click: function($event) {
                            return _vm.$emit("disable")
                          }
                        }
                      },
                      [
                        _c("v-icon", {
                          staticClass: "mr-1",
                          attrs: { name: "buttons/check", size: 12 }
                        }),
                        _vm._v(" "),
                        _c("small", { staticStyle: { "font-size": "12px" } }, [
                          _vm._v("Больше не подсказывать")
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-button",
                      {
                        staticClass: "custom-btn-primary",
                        on: {
                          click: function($event) {
                            return _vm.$emit("next")
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.isLastStep ? "Ок" : "Далее") +
                            "\n        "
                        )
                      ]
                    )
                  ],
                  1
                )
              ])
            ]
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-73294150", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73294150","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/utilites/commonUi/Onboarding.vue
// module id = null
// module chunks = 